export { default } from "./ModalContent-component";